'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.addTemplates = addTemplates;
exports.getTemplate = getTemplate;

var _config = require('../core/config');

var _config2 = _interopRequireDefault(_config);

var _localize = require('../utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _localize3 = require('../core/localize');

var _localize4 = _interopRequireDefault(_localize3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = require('debug')('linksoft:datatables:templates');
var Resx = (0, _localize4.default)('Common');

function createLink(urlName, args) {
    var fn = (0, _config2.default)().url[urlName];
    var url = "javascript:void(0)";
    if (typeof fn === 'function') {
        url = fn(args);
    } else {
        log('Function window.linksoft.url.' + urlName + ' is missing.');
    }
    return '<a href="' + url + '">' + args.name + '</a>';
}

var templates = {

    download: function download(e, urlName) {
        return '<a href="' + (0, _config2.default)().url[urlName](e.value) + '" title="' + (0, _localize2.default)('Common:Download') + '"><span class="fa fa-download"></span></a>';
    },
    deleteItem: function deleteItem(e) {
        return '<a data-table-delete="' + e.value + '" title="' + (0, _localize2.default)('Common:Delete') + '"><i class="fa fa-remove"></i></a>';
    },

    percentage: function percentage(e) {
        return e.value + '&nbsp;%';
    },

    /**
     * DEPRECATED!!! We use LookupColumn renderer now.
     * @param e
     * @returns {*|string}
     */
    lookup: function lookup(e) {
        return (e.value ? e.value.name : e.value) || '-';
    },

    link: function link(e, urlName, key) {
        if ((0, _isArray2.default)(e.value)) {
            return e.value.map(function (x) {
                return createLink(urlName, x);
            }).join(e.formatString || '');
        }

        var args = {};
        if (typeof key === 'string') {
            args.id = this[key];
        }

        var dto = (0, _assign2.default)({}, _typeof(e.value) === 'object' ? e.value : { id: e.value, name: e.value }, args);
        return createLink(urlName, dto);
    },

    /**
     * DEPRECATED!!! We are using EnumColumn renderer now.
     * @param e
     * @param enumType
     * @returns {*}
     */
    enumText: function enumText(e, enumType) {
        var enums = e.meta.settings.oInit.enums;
        var item = enums[enumType].find(function (x) {
            return x.id === e.value || x.value == e.value;
        });
        return item ? item.text : null;
    }
};

function addTemplates(objectWithTemplates) {
    (0, _assign2.default)(templates, objectWithTemplates);
}

function getTemplate(templateName) {
    return templates[templateName];
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/templates.js
// module id = 90
// module chunks = 0